import React from 'react';
import { Leaf } from 'lucide-react';
import { menuItems } from '../data/mock';

const MenuSection = () => {
  const allDishes = [
    ...menuItems.mainDishes,
    ...menuItems.snacks,
    ...menuItems.desserts
  ];
  
  return (
    <section className="py-20 bg-gradient-to-b from-white to-slate-50">
      <div className="container mx-auto px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Nabídka pokrmů
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Výběr z lahodných jídel připravených z čerstvých surovin přímo na místě
            </p>
          </div>
          
          {/* Main Dishes */}
          <div className="mb-16">
            <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">
              Hlavní jídla
            </h3>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {menuItems.mainDishes.map((dish) => (
                <div
                  key={dish.id}
                  className="group bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100 hover:shadow-2xl transition-all duration-300 hover:-translate-y-1"
                >
                  <div className="relative h-56 overflow-hidden bg-gray-100">
                    <img
                      src={dish.image}
                      alt={dish.name}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    {dish.vegetarian && (
                      <div className="absolute top-4 right-4 bg-cyan-600 text-white px-3 py-1 rounded-full text-sm font-medium flex items-center space-x-1">
                        <Leaf className="w-4 h-4" />
                        <span>Vegetariánské</span>
                      </div>
                    )}
                  </div>
                  <div className="p-6">
                    <h4 className="text-xl font-bold text-gray-900 mb-2">
                      {dish.name}
                    </h4>
                    <p className="text-gray-600 mb-4 text-sm leading-relaxed">
                      {dish.description}
                    </p>
                    <div className="text-sm text-gray-500">
                      {dish.weight}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          {/* Snacks */}
          <div className="mb-16">
            <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">
              Občerstvení
            </h3>
            <div className="grid md:grid-cols-3 gap-8">
              {menuItems.snacks.map((dish) => (
                <div
                  key={dish.id}
                  className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100 hover:shadow-2xl transition-all duration-300"
                >
                  <div className="relative h-48 overflow-hidden bg-gray-100">
                    <img
                      src={dish.image}
                      alt={dish.name}
                      className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-6">
                    <h4 className="text-xl font-bold text-gray-900 mb-2">
                      {dish.name}
                    </h4>
                    <p className="text-gray-600 mb-4 text-sm">
                      {dish.description}
                    </p>
                    {dish.note && (
                      <p className="text-xs text-cyan-600 font-medium mb-3">
                        {dish.note}
                      </p>
                    )}
                    <div className="text-sm text-gray-500">
                      {dish.weight}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          {/* Desserts */}
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">
              Dezerty
            </h3>
            <div className="max-w-md mx-auto">
              {menuItems.desserts.map((dish) => (
                <div
                  key={dish.id}
                  className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100 hover:shadow-2xl transition-all duration-300"
                >
                  <div className="relative h-56 overflow-hidden bg-gray-100">
                    <img
                      src={dish.image}
                      alt={dish.name}
                      className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-6">
                    <h4 className="text-xl font-bold text-gray-900 mb-2">
                      {dish.name}
                    </h4>
                    <p className="text-gray-600 mb-4 text-sm">
                      {dish.description}
                    </p>
                    <div className="text-sm text-gray-500">
                      {dish.weight}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MenuSection;
